export enum Species {
	// Dog = 2,
	// Cat = 1,
	Dog = 'Dog',
	Cat = 'Cat',
}
